document.addEventListener('DOMContentLoaded', function() {
  // HTMLの読み込みが完了した後に、この中身が実行されます

  // ===== CTAボタン：スムーススクロール =====
  document.querySelectorAll('.hase_cta-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const target = document.querySelector('.hase_form-title');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });

  // ===== trouble-item：左から順番にふわっと表示 =====
  const troubleItems = document.querySelectorAll('.hase_trouble-item');

  const troubleObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hase_is-visible');
        troubleObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2
  });

  troubleItems.forEach(function(item) {
    troubleObserver.observe(item);
  });

  // ===== .fade-in：ふわっと表示 =====
  const fadeItems = document.querySelectorAll('.hase_fade-in');

  const fadeObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hase_is-visible');
        fadeObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2
  });

  fadeItems.forEach(function(item) {
    fadeObserver.observe(item);
  });

});